"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SummaryWrapper = exports.Step1Root = exports.BasketCardForm = exports.BasketCard = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../constants");
const BasketCard = exports.BasketCard = (0, _mui.styled)('div')((param)=>{
    let { theme, noPadding } = param;
    return {
        backgroundColor: theme.palette.background.paper,
        padding: noPadding ? undefined : theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            borderRadius: theme.shape.largeComponentRadius
        }
    };
});
const BasketCardForm = exports.BasketCardForm = (0, _mui.styled)('form')((param)=>{
    let { theme, noPadding } = param;
    return {
        backgroundColor: theme.palette.background.paper,
        padding: noPadding ? undefined : theme.spacing(6),
        [theme.breakpoints.up('sm')]: {
            borderRadius: theme.shape.largeComponentRadius
        }
    };
});
const Step1Root = exports.Step1Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        boxSizing: 'content-box',
        margin: '0 auto',
        maxWidth: _constants.MAX_WIDTH,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: theme.spacing(4)
    };
});
Step1Root.displayName = 'Step1Root';
const SummaryWrapper = exports.SummaryWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        [theme.breakpoints.up('lg')]: {
            display: 'none'
        }
    };
});
SummaryWrapper.displayName = 'SummaryWrapper';
